import { Record } from 'immutable';

export interface MaxInactiveDaysInterface {
  maxInactiveDays: number;
  isBusyFetchingMeetingsToDelete: boolean;
  meetingsToBeDeleted?: Array<object>;
}

export const initialState: MaxInactiveDaysInterface = {
  maxInactiveDays: 0,
  isBusyFetchingMeetingsToDelete: false,
  meetingsToBeDeleted: undefined
};

export default class MaxInactiveDaysState extends Record(initialState) {
}
